// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  // apiSecurityContratistaUrl: 'http://localhost:64688', //'http://localhost:58200',
  // apiSecurityEmpleadoUrl: 'http://localhost:6550', //'http://localhost:1953',
  // // apiSolicitudUrl: 'http://localhost:3000',
  // apiGatewayUrl: 'http://localhost:53120'

  //apiSecurityContratistaUrl: 'http://contratistas-identity-api.azurewebsites.net',
  //apiSecurityEmpleadoUrl: 'http://empleados-identity-api.azurewebsites.net',  
  // apiSolicitudUrl: 'http://engieaccesosapi.azurewebsites.net',
  //apiGatewayUrl: 'http://engieaccesosapi.azurewebsites.net'


  apiSecurityContratistaUrl: 'https://appwebserviceprd.engie-energia.pe/Gateway.Contratistas',
  apiSecurityEmpleadoUrl: 'https://appwebserviceprd.engie-energia.pe/Gateway.Empleados',  
  apiGatewayUrl: 'https://appwebserviceprd.engie-energia.pe/Gateway.GestionDoc-Contratistas'

};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
